export default __webpack_public_path__ + "static/media/79cbe576557eb480.0f11eefcfa5738666e72ab50df96aa74.svg";